import dateUtils from "../Utils/dateUtils";

export default {
  getMyTasks: (token) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      'https://www.wrike.com/api/v4/tasks?responsibles=["KUAITNEI"]',
      requestOptions
    ).then((res) => res.json());
  },

  getTasksFolder: (token, idFolder, descendants = true, thisMonth = true) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let dateString = dateUtils.parseDate(new Date(), false);
    let date = new Date();
    let firstDay =
      dateString + new Date(date.getFullYear(), date.getMonth(), 1).getDate();
    let lastDay =
      dateString +
      new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

    return fetch(
      `https://www.wrike.com/api/v4/folders/${idFolder}/tasks?descendants=${descendants}${
        thisMonth
          ? `&scheduledDate={"start":"${firstDay}","end":"${lastDay}"}`
          : ""
      }`,
      requestOptions
    ).then((res) => res.json());
  },
  createTasksFolder: (token, idFolder, title, description) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var raw = JSON.stringify({
      title,
      description,
      responsibles: ["KUAITNEI"],
      customStatus: "IEAAWTQIJMAAAAAA",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    return fetch(
      `https://www.wrike.com/api/v4/folders/${idFolder}/tasks`,
      requestOptions
    ).then((res) => res.json());
  },
};
